import { useEffect, useState } from "react";

type LinkTagStatus = "idle" | "loading" | "ready" | "error";

export const useLinkTag = (href: string | null): LinkTagStatus => {
  const [status, setStatus] = useState<LinkTagStatus>(
    href ? "loading" : "idle",
  );

  useEffect(() => {
    if (!href) {
      setStatus("idle");
      return;
    }

    let link: HTMLLinkElement | null = document.querySelector(
      `link[href="${href}"]`,
    );

    if (!link) {
      link = document.createElement("link");
      link.href = href;
      link.rel = "stylesheet";
      link.type = "text/css";
      link.setAttribute("data-status", "loading");

      document.body.appendChild(link);

      const setAttributeFromEvent = (event: Event) => {
        link?.setAttribute(
          "data-status",
          event.type === "load" ? "ready" : "error",
        );
      };

      link.addEventListener("load", setAttributeFromEvent);
      link.addEventListener("error", setAttributeFromEvent);
    } else {
      setStatus(link.getAttribute("data-status") as LinkTagStatus);
    }

    const setStateFromEvent = (event: Event) => {
      setStatus(event.type === "load" ? "ready" : "error");
    };

    link.addEventListener("load", setStateFromEvent);
    link.addEventListener("error", setStateFromEvent);

    return () => {
      if (link) {
        link.removeEventListener("load", setStateFromEvent);
        link.removeEventListener("error", setStateFromEvent);
      }
    };
  }, [href]);

  return status;
};
